import React from "react";
import { Row, Col, Checkbox, Divider } from "antd";
import "./tablePermissionSection.css";

const TablePermissionsSection = ({
  isProfileCase,
  disabledCheckBox,
  permissions = {},
  handlePermissionChange,
  labStatus,
}) => {
  // Return null when no project is selected (show nothing)
  if (disabledCheckBox) {
    return null;
  }

  const handleCheckboxChange = (section, permissionKey, checked) => {
    // If unchecking the view permission, uncheck all other permissions
    if (section === 'general' && permissionKey === 'view' && !checked) {
      // Create a list of all sections
      const allSections = ['general'];
      
      // For each section, uncheck all permissions
      allSections.forEach(sec => {
        if (permissions[sec]) {
          Object.keys(permissions[sec]).forEach(key => {
            if (permissions[sec][key]) {
              handlePermissionChange(sec, key, false);
            }
          });
        }
      });
    } else {
      // If the view permission is not checked, don't allow other permissions to be checked
      if (section !== 'general' || permissionKey !== 'view') {
        if (checked && !permissions?.general?.view) {
          // If trying to check a permission but view is not enabled, don't allow it
          return;
        }
      }
      
      // Normal case: just update the specific permission
      handlePermissionChange(section, permissionKey, checked);
    }
  };

  const renderCheckbox = (section, key, label, isHeader = false) => (
    <div className={`checkbox-div ${isHeader ? 'header' : ''}`} key={`${section}-${key}`}>
      <Checkbox
        checked={permissions[section]?.[key] || false}
        onChange={(e) => handleCheckboxChange(section, key, e.target.checked)}
        disabled={disabledCheckBox}
      >
        <span className={isHeader ? 'uppercase-label' : 'normal-label'}>
          {label}
        </span>
      </Checkbox>
    </div>
  );
  
  const renderSection = (section, title, items) => {
    const isGeneral = section === 'general';
    
    return (
      <Col 
        className={`lab-permission-section multiple-col ${
          isGeneral ? 'general-section' : ''
        }`} 
        style={{ marginRight: '10px' }}
      >
        <div className="label-div">
          <span className="section-title">
            {title}
          </span>
        </div>
        {items.map(([key, label]) => renderCheckbox(section, key, label))}
      </Col>
    );
  };

  const generalItems = [
    ['add_edit', 'Add/Edit'],
    ['view', 'View'],
    ['export', 'Export']
  ];

  return (
    <div className="table-permission-section">
      <div className="section-title">
       STOCK MANAGEMENT{labStatus && `- ${labStatus}`}
      </div>
      <Row className="permission-row-div" style={{ display: 'flex', flexWrap: 'wrap' }}>
        {renderSection('general', 'GENERAL', generalItems)}
      </Row>
    </div>
  );
};

export default TablePermissionsSection;
